<ng-container *transloco="let t; read: 'LOGS_MODAL_COMPONENT'">
  <ion-toolbar>
    <div class="toolbar-header">
      <ion-button (click)="dismissModal()" fill="none" color="secondary">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
      <h1>{{ t('TITLE') }}</h1>
      <div class="right"></div>
    </div>
  </ion-toolbar>
  <ion-content>
    <ion-accordion-group (ionChange)="fetchStore($event)">
      <ion-accordion *ngFor="let store of stores" [value]="store.name">
        <ion-item slot="header" color="light">
          <ion-label
            >{{ store.name }} <span *ngIf="store.date">- {{ store.date | translocoDate: { timeStyle: 'medium' } }}</span></ion-label
          >
        </ion-item>
        <pre slot="content"><code>{{store.data | json}}</code></pre>
      </ion-accordion>
    </ion-accordion-group>
  </ion-content>
</ng-container>
